import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule }   from '@angular/forms'; 

import { AppComponent } from './app.component';
import { MediaComponent } from './media/media.component';
import {HttpModule} from '@angular/http';
import { LoadingModule } from 'ngx-loading';
import { MediaService } from './media.service';
import { PostService } from './post.service';
import { PostComponent } from './post/post.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    AppComponent,
    MediaComponent,
    PostComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    FormsModule,
    LoadingModule,
    NgbModule.forRoot()
  ],
  providers: [MediaService, PostService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/app.module.ts